export const colors = {
  primary: "#2170EA",
  primary1: "#05B1F4",
  primary2: "#14233D",

  success: "rgb(52, 199, 123)",
};
